/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const MODAL_THEME = {
  baseStyle: {
    dialog: {
      maxWidth: { base: "100vw", md: undefined },
      maxHeight: { base: "100vh", md: undefined },
      m: { base: 0, md: undefined },
    },
  },
  defaultProps: {
    isCentered: true,
  },
};
